import { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import './NavItem.scss';

const NavItem = ({ item }) => {
    const [open, setOpen] = useState(false);
    const timerRef = useRef(null);
    const { pathname } = useLocation();

    const handleMouseEnter = () => { clearTimeout(timerRef.current); if (item.items) setOpen(true); };
    const handleMouseLeave = () => { timerRef.current = setTimeout(() => setOpen(false), 120); };
    useEffect(() => () => clearTimeout(timerRef.current), []);

    const hasActiveChild = item.items ? item.items.some(child => child.path === pathname) : false;
    const isActive = pathname === item.path || hasActiveChild;

    if (!item.items) {
        return (
            <Link 
                to={item.path} 
                className={`nav-item__link${isActive ? ' nav-item__link--active' : ''}`}
            >
                {item.label}
            </Link>
        );
    }

    return (
        <div
            className={`nav-item${open ? ' nav-item--open' : ''}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <button className={`nav-item__trigger${isActive ? ' nav-item__trigger--active' : ''}`}>
                {item.label}
                <ChevronDown size={12} strokeWidth={2.5} className="nav-item__chevron" />
            </button>

            {open && (
                <div className="nav-item__panel">
                    <div className="nav-dropdown">
                        {item.items.map(i => {
                            const isSubActive = pathname === i.path;
                            return (
                                <Link
                                    key={i.path}
                                    to={i.path}
                                    className={`nav-dropdown__link${isSubActive ? ' nav-dropdown__link--active' : ''}`}
                                    onClick={() => setOpen(false)}
                                >
                                    {i.label}
                                </Link>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default NavItem;